module.exports = __webpack_public_path__ + "static/media/action_locked.0595f3dc.png";